import { render, staticRenderFns } from "./QrcodeScanner.vue?vue&type=template&id=63def0ca&"
import script from "./QrcodeScanner.vue?vue&type=script&lang=js&"
export * from "./QrcodeScanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports